import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73b7547b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "编号：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "名称：", -1))
const _hoisted_9 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"20px"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_13 = { class: "normal" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode("明细")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_20 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_21 = { class: "qp" }
const _hoisted_22 = { class: "my-header" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "详情", -1))

import { useRouter,useRoute } from 'vue-router';
	import { onMounted,ref,nextTick,computed } from 'vue';
	import { ElMessage } from 'element-plus';
	import { apiName } from '@/api/api';
	import { requestModelingList,requestModelingdel } from '@/api/xmApi';
	import TaskDetails from '@/views/Form/jianmoDetails.vue'
	
export default /*#__PURE__*/_defineComponent({
  name: 'jianmolist',
  setup(__props) {

	const api = ref<string>(apiName)
	const router = useRouter()
	const route = useRoute()
	const list = ref([])
	const loading = ref<boolean>(false)
	const addShowTask = ref<boolean>(false)//添加任务
	const addTask = ref<boolean>(false)
	const taskDetails = ref(false)//控制右侧弹窗
	const taskDetailsShow = ref(false)//控制右侧弹窗
	const form = ref('')
	const taskid = ref(route.params.taskid)
	const yuqi =ref(route.params.yuqi);
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		code:"",
		name:"",
	})
	const cancelDetails = () => {
		taskDetails.value = false
		getTaskList()
	}
	const cancelTask = (val:any) =>{
		addShowTask.value = false
		if(val){
			getTaskList()
		}
	}
	const searchList = () =>{
		pageIndex.value = 1
		getTaskList();
	}
	const mx = (id:number) => {
		details(id)
	}
	const details = (row:any) => {
		form.value = row
		console.log('1111111111')
		console.log(form)
		taskDetailsShow.value = false
		nextTick(()=>{
			taskDetailsShow.value = true
		})
		taskDetails.value = true
	}
	//刷新列表
	const taskListsx = () => {
		getTaskList()
		taskDetails.value = false
	}
	//新建任务
	const createTask = () => {
		tasksx()
		addShowTask.value = true
	}
	const tasksx = () => {
		addTask.value = false
		nextTick(()=>{
			addTask.value = true
		})
	}
	onMounted(()=>{
		getTaskList();
	})
	
	const getTaskList = () => {
		loading.value = true
		requestModelingList({
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			code:search.value.code,
			name:search.value.name,
		}).then((res:any)=>{
			list.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getTaskList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getTaskList();
	}
	const back = () =>{
		router.go(-1)
	}
	const del = (id:number) =>{
		console.log(id)
		requestModelingdel({
			id:id
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getTaskList();
				},500)
			}
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.code) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.name) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _ctx.Search,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (searchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (mx(0)))
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _hoisted_12,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: list.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "编号",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_13, _toDisplayString(scope.row.cell.code), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.name",
          label: "名称",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.typename",
          label: "类型名称",
          width: "300"
        }),
        _createVNode(_component_el_table_column, {
          label: "cad照片",
          width: "80"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.cadimg!='')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  style: {"color":"blue"},
                  href: scope.row.cell.cadimg,
                  target: "_blank"
                }, "查看", 8, _hoisted_14))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "cad文件",
          width: "80"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.cadfile!='')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  style: {"color":"blue"},
                  href: scope.row.cell.cadfile,
                  target: "_blank"
                }, "查看", 8, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "公式文件",
          width: "80"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.gsfile!='')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  style: {"color":"blue"},
                  href: scope.row.cell.gsfile,
                  target: "_blank"
                }, "查看", 8, _hoisted_16))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.remarks",
          label: "备注",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.cell.status==1?'success':'warning'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.cell.status==1?'已同步':'未同步'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作列",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              style: {"cursor":"pointer"},
              onClick: ($event: any) => (mx(scope.row.cell.id))
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _hoisted_18,
            _createVNode(_component_el_tag, {
              type: 'danger',
              style: {"cursor":"pointer"},
              onClick: ($event: any) => (del(scope.row.cell.id))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_el_dialog, {
        modelValue: taskDetails.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((taskDetails).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (cancelDetails()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (taskDetailsShow.value)
            ? (_openBlock(), _createBlock(TaskDetails, {
                key: 0,
                form: form.value,
                onTaskListsx: taskListsx
              }, null, 8, ["form"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})